module.exports = __webpack_public_path__ + "media/images/temp/accordion-image-5-3c1190a4b1f5d315317e6933b7aab76d.png";